module.exports = __webpack_public_path__ + "static/media/small_iphone.c0131b0a.png";